import { DataResourceContext, usePageCssSnippets } from '@nucleus/web-theme';
import { nucleusClass } from '@nucleus/web-theme-elements';
import React from 'react';
import { createGlobalStyle, css } from 'styled-components';
import { useEnabledCodeSnippets } from '../hooks/useEnabledCodeSnippets';
import { GlobalStyle } from './GlobalStyle';

export const PageGlobalStyle = (): JSX.Element => {
  const { page } = React.useContext(DataResourceContext);
  const cssSnippets = usePageCssSnippets();
  const enabledCssSnippets = useEnabledCodeSnippets(cssSnippets);
  const pageClass = nucleusClass('page');

  return (
    <>
      {enabledCssSnippets.map((snippet) => (
        <GlobalStyle key={snippet.id} content={snippet.content} selector={`.${pageClass}.${pageClass}`} />
      ))}
      {/* If the page has overrides for the logo color, render appropriate css */}
      <BrandingStyle mode={page?.branding?.mode} />
    </>
  );
};

const BrandingStyle = createGlobalStyle<{ mode?: 'auto' | 'dark' | 'light' }>`
  ${({ mode }) => {
    switch (mode) {
      case 'dark':
        return css`
          .${nucleusClass('type-header')} .${nucleusClass('branding')} .logo-light {
            opacity: 0;
          }
          .${nucleusClass('type-header')} .${nucleusClass('branding')} .logo-dark {
            opacity: 1;
          }
          .${nucleusClass('type-header')} .${nucleusClass('branding')} .branding-text {
            color: var(--color-dark);
          }
        `;
      case 'light':
        return css`
          .${nucleusClass('type-header')} .${nucleusClass('branding')} .logo-light {
            opacity: 1;
          }
          .${nucleusClass('type-header')} .${nucleusClass('branding')} .logo-dark {
            opacity: 0;
          }
          .${nucleusClass('type-header')} .${nucleusClass('branding')} .branding-text {
            color: var(--color-light);
          }
        `;
      default:
        return;
    }
  }}
`;
